import {Client} from "../../data/data-class/client/clientClass";
import ViaqTryCatch from "../../services/GlobalTryCatch";
import axiosInstance from "../../services/axios";

class ClientListRepository {
    static async getClientList(text, pageNumber) {
        const data = {
            text: text,
            pagenumber: pageNumber,
        };
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/client", data)
            });

        if (response.success) {
            const clientObject =  response.data.clients.map(item => new Client(item));
            const countAll = response.data.countAll;

            return {
                clients: clientObject,
                countAllPages: countAll,
                code: response.statusCode,
                massage: response.message,
            };
        }
        return {
            code: response.statusCode,
            massage: response.message,
        };

    }

    static async editAddClient(data) {
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/client/edit", data)
            });
        const code = response.statusCode;
        const message = response.message;

        return {
            code,
            message,
        };
    }

    static async deleteClient(id) {
        const data = {
            id: id,
        };
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/client/delete", data)
            });
        const code = response.statusCode;
        const message = response.message;

        return {
            code,
            message,
        };
    }

    static async passwordClient(id) {
        const data = {
            id: id,
        };

        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/client/password", data)
            });
        const pass = response.data.code;
        const code = response.statusCode;
        const message = response.message;
        return {
            code,
            message,
            pass,
        };
    }
}

export {ClientListRepository};
